import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import { SwiperSlide } from "swiper/react";
import { fetchEmployerTrustedBrand } from "../../../redux/actions/company_action";
import { CompaniesSkeleton } from "./CompaniesSkeleton";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  CarouselContainer,
  CompanyButtons,
  LogoContainer,
  LogoStyled,
  SwiperStyled,
  TitleContainer,
  TitleStyled,
  TrustedCompanyGrid,
} from "./styles";

const swiperSettings = {
  modules: [Autoplay],
  loop: true,
  slidesPerView: 3,
  spaceBetween: 30,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  speed: 3000,
  breakpoints: {
    480: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    600: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 25,
    },
    1280: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    1281: {
      slidesPerView: 6,
      spaceBetween: 15,
    },
  },
};

const reverseSwiperSettings = {
  modules: [Autoplay],
  loop: true,
  slidesPerView: 3,
  spaceBetween: 30,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    reverseDirection: true,
  },
  speed: 3000,
  breakpoints: {
    480: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    600: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 25,
    },
    1280: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    1281: {
      slidesPerView: 6,
      spaceBetween: 15,
    },
  },
};

function EmployerLandingCompanies(props) {
  const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
  const companies = isMalaysia ? content_my : content_sg;

  // Malaysia → split into 2 rows of 8 each
  const firstRowCompanies = isMalaysia ? companies.slice(0, 8) : companies;
  const secondRowCompanies = isMalaysia ? companies.slice(8, 16) : [];

  // const order = [
  //   "uniqlo",
  //   "storehub",
  //   "canon",
  //   "ocbc",
  //   "silverlake",
  //   "zus-coffee",
  //   "agoda",
  //   "grab",
  //   "shopee",
  //   "singapore-airline",
  //   "forvis-mazars",
  //   "coway",
  //   "ninja-van",
  //   "tesla",
  //   "intel",
  //   "j&t",
  // ];

  // const companies2 = order
  //   .reverse()
  //   .map((name) => companies.find((company) => company.name == name));

  // const reversedCompanies = isMalaysia ? companies2 : companies;

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const isTablet = useMediaQuery("(max-width:768px)");
  const isMobile = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    dispatch(fetchEmployerTrustedBrand()).finally(() => {
      setLoading(false);
    });
  }, [dispatch]);

  return (
    <TrustedCompanyGrid
      container
      justifyContent={"center"}
      flexDirection={"column"}
      alignItems={"center"}
    >
      {loading ? (
        <>
          <CompaniesSkeleton />
        </>
      ) : (
        <>
          <TitleContainer>
            <TitleStyled>
              {isMalaysia ? (
                <>
                  Trusted by <span>7,000+</span> companies nationwide
                </>
              ) : (
                <>
                  Trusted by Singapore's <span>Best</span>
                </>
              )}
            </TitleStyled>
          </TitleContainer>

          <TitleContainer>
            <TitleStyled type={"subtitle"}>
              Click to see how companies collaborate with us
            </TitleStyled>
          </TitleContainer>

          <CarouselContainer container justifyContent={"center"}>
            <SwiperStyled {...swiperSettings}>
              {firstRowCompanies.map((company, index) => (
                <SwiperSlide key={index}>
                  <CompanyButtons
                    href={company.clickThroughURL}
                    target="_blank"
                    rel="noopener"
                  >
                    <LogoContainer>
                      <LogoStyled
                        alt={
                          company?.brandLogo?.data?.attributes
                            ?.alternativeText ?? `company-logo-${index}`
                        }
                        src={company?.brandLogo?.data?.attributes?.url}
                      />
                    </LogoContainer>
                  </CompanyButtons>
                </SwiperSlide>
              ))}
            </SwiperStyled>
          </CarouselContainer>

          {isMalaysia && secondRowCompanies.length > 0 && (
            <CarouselContainer container justifyContent={"center"}>
              <SwiperStyled {...reverseSwiperSettings}>
                {secondRowCompanies.map((company, index) => (
                  <SwiperSlide key={index}>
                    <CompanyButtons
                      href={company.clickThroughURL}
                      target="_blank"
                      rel="noopener"
                    >
                      <LogoContainer>
                        <LogoStyled
                          alt={
                            company?.brandLogo?.data?.attributes
                              ?.alternativeText ?? `company-logo-${index}`
                          }
                          src={company?.brandLogo?.data?.attributes?.url}
                        />
                      </LogoContainer>
                    </CompanyButtons>
                  </SwiperSlide>
                ))}
              </SwiperStyled>
            </CarouselContainer>
          )}
        </>
      )}
    </TrustedCompanyGrid>
  );
}

export default EmployerLandingCompanies;
